export default __webpack_public_path__ + "static/media/qr.87e6d418.svg";